const state = {
    userInfo: {
        avatar: null,
        series: null,
        userId: null,
        userName: null,
        role: null,
        siteId: null,
        code: null,
        token: null,
       mobile: null,
        sex: null,
        needJsToGetUserInfo: true
    }
}

const getters = {
    getUserInfo: (state) => {
        return state.userInfo;
    },
}

const mutations = {
    SET_USER_INFO: (state, userInfo) => {
        state.userInfo = userInfo;
    },
    SET_NEED_JS_USER_INFO: (state, needJsToGetUserInfo) => {
        state.userInfo.needJsToGetUserInfo = needJsToGetUserInfo;
    },
}

const actions = {
    updateUserInfo(context, userInfo) {
        context.commit('SET_USER_INFO', userInfo);
    },
    updateUserJsUserInfo(context, needJsToGetUserInfo) {
        context.commit('SET_NEED_JS_USER_INFO', needJsToGetUserInfo);
    }
}

export default {
    //namespaced: true,
    state,
    getters,
    actions,
    mutations
}
